import React from 'react';
import Box from '@mui/material/Box';
import {
    default as CircularProgress,
    CircularProgressProps,
} from '@mui/material/CircularProgress';
import qualityLogo from 'static/assets/icons/branding/quality_logo.svg';
import { styled } from '@mui/material/styles';

interface LoaderProps extends CircularProgressProps {
    message?: string;
}

const LoaderBoxLayer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '20px',
    img: {
        width: '120px',
    },
}));

const Loader: React.FC<LoaderProps> = ({ message, ...loaderProps }) => {
    return (
        <LoaderBoxLayer>
            <Box component="img" alt="Loading Content" src={qualityLogo} />
            {message}
            <CircularProgress size="3rem" {...loaderProps} />
        </LoaderBoxLayer>
    );
};

export default Loader;
